import { Tabs } from 'react-vant'
import Survey from './components/Survey'
import SatisfactionLevel from './components/SatisfactionLevel'
import { Helmet } from '@umijs/max'

const Questionnaire = () => {
  const itemList = [{
    key: 1,
    label: '问卷调查',
    name: 'Survey'
  },{
    key: 2,
    label: '满意度调查',
    name: 'SatisfactionLevel'
  }]
  return (
    <div className='demo-tabs'>
       <Helmet><title>问卷</title></Helmet>
      <Tabs defaultActive={0} sticky={true}>
        {itemList.map(item => (
          <Tabs.TabPane key={item.key} title={`${item.label}`}>
            {item.key === 1 ? (<>
             <Survey></Survey>
            </>) : (
              <><SatisfactionLevel></SatisfactionLevel></>)}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  )
}

export default Questionnaire